// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-364f824c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./matters.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-loader/node_modules/vue-style-loader/lib/addStylesClient.js")("67f8c230", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-364f824c","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/sign/matters.vue
// module id = 619
// module chunks = 0